<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">{{ client.firma ? client.firma.NAZWA_PELNA : client.nazwa_pelna }}</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients.show', client.id)">Kontakty</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      {{ form.first_name }} {{ form.last_name }}
    </h1>

    <trashed-message v-if="contact.deleted_at" class="mb-6" @restore="restore">
      Kontakt jest oznaczony jako usunięty.
    </trashed-message>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full xl:w-1/2">
        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <multiselect-input v-model="form.udzialowiec" :error="form.errors.udzialowiec" class="pr-6 pb-8 w-full" :options="client.firma.udzialowcy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Udziałowiec [WAPRO]" :searchable="true" :isDisabled="form.udzialowiec!=null" />

            <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Imię" />
            <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nazwisko" />
            <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Telefon" />
            <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Adres e-mail" />
            <text-input v-model="form.pesel" :error="form.errors.pesel" class="pr-6 pb-8 w-full lg:w-1/2" label="Pesel" />
            <text-input v-model="form.stanowisko" :error="form.errors.stanowisko" class="pr-6 pb-8 w-full lg:w-1/2" label="Stanowisko" />

            

            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/3" v-model:checked.sync="form.is_default" :error="form.errors.is_default" :checked="form.is_default" label="Domyślny"  />
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/3" v-model:checked.sync="form.is_ceo" :error="form.errors.is_ceo" :checked="form.is_ceo" label="Właściciel"  />
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/3" v-model:checked.sync="form.is_contract_representative" :error="form.errors.is_contract_representative" :checked="form.is_contract_representative" label="Reprezentant na umowie" />

            <shtax-text-area-input class="pr-6 pb-8 w-full" v-model="form.notice" :error="form.errors.notice" label="Uwagi"  />
          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
            <button v-if="!contact.deleted_at && $page.props.can['delete contacts']" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Usuń kontakt</button>
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Zaktualizuj dane</loading-button>
          </div>
        </form>
      </div>

      <div class="mt-12 xl:mt-0 xl:px-8 w-full xl:w-1/2" v-if="contact.udzialowiec">
        <h3 class="mb-2 font-bold text-lg md:text-md ">
          Historia udziałowca
        </h3>
        <div class="mt-2 bg-white rounded shadow overflow-x-auto text-sm">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="px-3 pt-3 pb-2">Rok</th>
              <th class="px-3 pt-3 pb-2">Forma opodatkowania</th>
              <th class="px-3 pt-3 pb-2">Liniowy</th>
            </tr>
            <tr v-for="history in contact.udzialowiec.historia" :key="history.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t">
                <span class="px-3 py-2 flex items-center focus:text-shtax-500">
                  {{ history.Rok }}
                </span>
              </td>
              <td class="border-t">
                <span class="px-3 py-2 flex items-center" tabindex="-1">
                  {{ history.sposob_rozliczania_podatku == 1 ? 'Na zasadach ogólnych' : 'Ryczałt' }}
                </span>
              </td>
              <td class="border-t">
                <span class="px-3 py-2 flex items-center whitespace-normal" tabindex="-1">
                  {{ history.LINIOWY_PD == 1 ? 'Tak' : '' }}
                </span>
              </td>
            </tr>
            <tr v-if="contact.udzialowiec.historia.length === 0">
              <td class="border-t px-3 py-2" colspan="3">Historia udziałowca jest pusta.</td>
            </tr>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import TrashedMessage from '@/Shared/TrashedMessage'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo() {
    return {
      title: `${this.form.first_name} ${this.form.last_name}`,
    }
  },
  components: {
    LoadingButton,
    TextInput,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    TrashedMessage,
    MultiselectInput
  },
  layout: Layout,
  props: {
    contact: Object,
    client: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        email: this.contact.email,
        phone: this.contact.phone,
        pesel: this.contact.pesel,
        is_default: this.contact.is_default,
        is_ceo: this.contact.is_ceo,
        notice: this.contact.notice,
        udzialowiec: this.contact.udzialowiec,
        stanowisko: this.contact.stanowisko,
        is_contract_representative: this.contact.is_contract_representative
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('contacts.update', {'client':this.client.id, 'contact':this.contact.id}))
    },
    
    destroy() {
      if (confirm('Jesteś pewien że chcesz usunąć wybrany kontakt kontrahenta?')) {
        this.$inertia.delete(this.route('contacts.destroy', {'client':this.client.id, 'contact':this.contact.id}))
      }
    },

    restore() {
      if (confirm('Jesteś pewien że chcesz przywrócić wybrany kontakt kontrahenta?')) {
        this.$inertia.put(this.route('contacts.restore', {'client':this.client.id, 'contact':this.contact.id}))
      }
    },

  },

}
</script>
